// ============================================================
// TimberTech product catalog — verified against timbertech.com
// (deck-collections + colors + railing-overview, Aug/Sep 2026).
// This is the LOCAL FALLBACK. The live site reads the same data
// from the CMS (content key "timbertech_catalog").
//
// Per-color structure (easy to upgrade later):
//   name    — exact official color name
//   hex/hex2 — APPROXIMATE screen representation (fallback swatch).
//              Replace with official swatch/board imagery once
//              TimberTech asset use is approved (add `image`).
//   url     — most relevant official TimberTech page (collection)
//   sample  — official TimberTech sample page
// ============================================================

export const TT_LINKS = {
  colors: "https://www.timbertech.com/colors/",
  collections: "https://www.timbertech.com/products/decking-overview/deck-collections/",
  railing: "https://www.timbertech.com/products/railing/railing-overview/",
  samples: "https://www.timbertech.com/order-samples/",
};

const SAMPLES = TT_LINKS.samples;

const C = (name, hex, hex2, url) => ({ name, hex, hex2, url, sample: SAMPLES });

export const TT_COMPOSITE = [
  {
    collection: "Legacy Collection",
    url: "https://www.timbertech.com/product/pro-legacy-collection/",
    colors: [
      C("Whitewash Cedar", "#E3DACA", "#D1C5B0", "https://www.timbertech.com/product/pro-legacy-collection/"),
      C("Ashwood", "#8B8177", "#6E665C", "https://www.timbertech.com/product/pro-legacy-collection/"),
      C("Pecan", "#96684A", "#7A5437", "https://www.timbertech.com/product/pro-legacy-collection/"),
      C("Tigerwood", "#B87B42", "#9A6430", "https://www.timbertech.com/product/pro-legacy-collection/"),
      C("Mocha", "#5E4634", "#47352A", "https://www.timbertech.com/product/pro-legacy-collection/"),
      C("Espresso", "#33261C", "#221710", "https://www.timbertech.com/product/pro-legacy-collection/"),
    ],
  },
  {
    collection: "Reserve Collection",
    url: "https://www.timbertech.com/product/pro-reserve-collection/",
    colors: [
      C("Antique Leather", "#C0A184", "#A5886B", "https://www.timbertech.com/product/pro-reserve-collection/"),
      C("Dark Roast", "#3B2E24", "#2A1F17", "https://www.timbertech.com/product/pro-reserve-collection/"),
      C("Driftwood", "#9C968A", "#868176", "https://www.timbertech.com/product/pro-reserve-collection/"),
      C("Reclaimed Chestnut", "#7D5A3E", "#644730", "https://www.timbertech.com/product/pro-reserve-collection/"),
    ],
  },
  {
    collection: "Terrain+ Collection",
    url: "https://www.timbertech.com/product/composite-terrain-plus-collection/",
    colors: [
      C("Dark Oak", "#4E3A2A", "#3B2B1E", "https://www.timbertech.com/product/composite-terrain-plus-collection/"),
      C("Natural White Oak", "#CDBFA3", "#B7A88B", "https://www.timbertech.com/product/composite-terrain-plus-collection/"),
      C("Weathered Oak", "#A09076", "#857763", "https://www.timbertech.com/product/composite-terrain-plus-collection/"),
    ],
  },
  {
    collection: "Terrain Collection",
    url: "https://www.timbertech.com/product/pro-terrain-collection/",
    colors: [
      C("Silver Maple", "#BCB6AA", "#A6A094", "https://www.timbertech.com/product/pro-terrain-collection/"),
      C("Brown Oak", "#6E5236", "#583F27", "https://www.timbertech.com/product/pro-terrain-collection/"),
    ],
  },
  {
    collection: "Premier+ Collection",
    url: "https://www.timbertech.com/product/premier-plus-collection/",
    colors: [
      C("Natural Oak", "#C2A87F", "#A88F64", "https://www.timbertech.com/product/premier-plus-collection/"),
    ],
  },
  {
    collection: "Prime+ Collection",
    url: "https://www.timbertech.com/product/edge-prime-plus-collection/",
    colors: [
      C("Sea Salt Gray", "#D2CFC6", "#BBB7AD", "https://www.timbertech.com/product/edge-prime-plus-collection/"),
      C("Coconut Husk", "#7E6A50", "#64543D", "https://www.timbertech.com/product/edge-prime-plus-collection/"),
      C("Dark Cocoa", "#332722", "#241A16", "https://www.timbertech.com/product/edge-prime-plus-collection/"),
    ],
  },
  {
    collection: "Prime Collection",
    url: "https://www.timbertech.com/product/edge-prime-collection/",
    colors: [
      C("Maritime Gray", "#A29E96", "#8A867E", "https://www.timbertech.com/product/edge-prime-collection/"),
      C("Dark Teak", "#453120", "#312217", "https://www.timbertech.com/product/edge-prime-collection/"),
    ],
  },
];

export const TT_PVC = [
  {
    collection: "Vintage Collection",
    url: "https://www.timbertech.com/product/azek-vintage-collection/",
    colors: [
      C("Weathered Teak", "#A8927A", "#8F7A63", "https://www.timbertech.com/product/azek-vintage-collection/"),
      C("Cypress", "#7F6244", "#66503A", "https://www.timbertech.com/product/azek-vintage-collection/"),
      C("Coastline", "#B8B8B0", "#A2A29A", "https://www.timbertech.com/product/azek-vintage-collection/"),
      C("Mahogany", "#7A4230", "#5E3220", "https://www.timbertech.com/product/azek-vintage-collection/"),
      C("English Walnut", "#52392A", "#3D2A1D", "https://www.timbertech.com/product/azek-vintage-collection/"),
      C("Dark Hickory", "#2E241B", "#1E1610", "https://www.timbertech.com/product/azek-vintage-collection/"),
    ],
  },
  {
    collection: "Landmark Collection",
    url: "https://www.timbertech.com/product/azek-landmark-collection/",
    colors: [
      C("French White Oak", "#DED2B8", "#C9BC9F", "https://www.timbertech.com/product/azek-landmark-collection/"),
      C("American Walnut", "#5F4330", "#483020", "https://www.timbertech.com/product/azek-landmark-collection/"),
      C("Castle Gate", "#8A857C", "#716C64", "https://www.timbertech.com/product/azek-landmark-collection/"),
      C("Boardwalk", "#C0B294", "#A59677", "https://www.timbertech.com/product/azek-landmark-collection/"),
    ],
  },
  {
    collection: "Harvest+ Collection",
    url: "https://www.timbertech.com/product/harvest-plus-collection/",
    colors: [
      C("Toasted Wheat", "#D2B284", "#B6996A", "https://www.timbertech.com/product/harvest-plus-collection/"),
      C("Timber Gray", "#8F8C86", "#767370", "https://www.timbertech.com/product/harvest-plus-collection/"),
    ],
  },
  {
    collection: "Harvest Collection",
    url: "https://www.timbertech.com/product/azek-harvest-collection/",
    colors: [
      C("Slate Gray", "#7E7E7E", "#666666", "https://www.timbertech.com/product/azek-harvest-collection/"),
      C("Kona", "#463427", "#30231A", "https://www.timbertech.com/product/azek-harvest-collection/"),
      C("Brownstone", "#93816C", "#79685A", "https://www.timbertech.com/product/azek-harvest-collection/"),
    ],
  },
];

export const TT_RAILING = [
  {
    family: "Classic Composite Series",
    kind: "Composite railing",
    topRails: ["Premier Rail", "RadianceRail", "Trademark Rail", "Drink Rail"],
    infills: ["Composite square balusters", "Aluminum balusters (square or round, black)", "CableRail", "Glass channel kit"],
    colors: ["White", "Matte White", "Matte Black", "Matte Espresso"],
    note: "Available options vary by railing configuration — some top rails and colors pair with specific infills and lengths.",
  },
  {
    family: "Impression Rail Express",
    kind: "Powder-coated aluminum railing",
    topRails: ["Classic Top Rail", "Modern Top Rail", "Drink Rail"],
    infills: ["Aluminum balusters", "Open mid-rail", "Glass channel kit", "Vertical cable rail", "Horizontal cable rail"],
    colors: ["Black", "White", "Dark Bronze"],
    note: "Available options vary by railing configuration — the Drink Rail, for example, does not pair with glass infill.",
  },
  {
    family: "Additional TimberTech railing families",
    kind: "More options",
    topRails: [],
    infills: [],
    colors: [],
    note: "TimberTech also offers Pinnacle Rail, Statement Rail, Fulton Rail, and Reliance Rail. We review the full current lineup and compatibility during your free on-site estimate.",
  },
];
